import React, { useState, useEffect } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import toast, { Toaster } from "react-hot-toast";
import { API_URL, HOSTNAME } from "../../services/api";
import { FaRegCopy, FaPencilAlt, FaFileExport } from "react-icons/fa";
import { useGetPagination } from "../../services/GetService";
import { Link } from "react-router-dom";
import Key from "../../util/Key";
import Table from "react-bootstrap/Table";
import PaginationComponent from "../../util/pagination/pagination";
import Search from "../../util/search/search";
import { useCookies } from "react-cookie";
import export_db from "./service";

const MyForms = ({ setShowLoading }) => {
    const [paginate, setPaginate] = useState(API_URL + "my-forms");
    const [response] = useGetPagination(paginate);
    const [token, setToken] = useCookies(["token"]);

    useEffect(() => {
        response.length != [] && setShowLoading(false);
    }, [response]);
    return (
        <div className="container">
            <Toaster position="top-center" reverseOrder={false} />
            <div className="col-12 d-flex mt-5">
                <div className="col-9"></div>
                <div className="col-3">
                    <Search
                        setPaginate={setPaginate}
                        url="forms"
                        originalUrl="my-forms"
                    />
                </div>
            </div>
            <div className="col-12 table-responsive">
                <Table className="table  caption-top  ">
                    <thead>
                        <tr>
                            <th scope="col">N°</th>
                            <th scope="col">Empresa</th>
                            <th scope="col">Enviar a</th>
                            <th scope="col">Nombre</th>
                            <th scope="col">Url Formulario</th>
                        </tr>
                    </thead>
                    <tbody>
                        {response.data !== undefined &&
                            response.data.map((item) => {
                                return (
                                    <tr key={item.id} onClick={() => { }}>
                                        <th scope="row">{item.id}</th>
                                        <td>{item.company.name}</td>
                                        <td>
                                            {item.sendMailsArray.map((mail) => {
                                                return (
                                                    <p key={Key()}>
                                                        {mail.sendTo}
                                                    </p>
                                                );
                                            })}
                                        </td>
                                        <td>{item.name}</td>

                                        <td>
                                            {HOSTNAME +
                                                "form/" +
                                                item.form_code}
                                        </td>
                                        <td>
                                            <CopyToClipboard
                                                text={
                                                    HOSTNAME +
                                                    "form/" +
                                                    item.form_code
                                                }
                                            >
                                                <FaRegCopy
                                                    className="btnAciones link-primary"
                                                    onClick={() =>
                                                        toast.success(
                                                            "Copied to clipboard"
                                                        )
                                                    }
                                                />
                                            </CopyToClipboard>
                                        </td>
                                        <td>
                                            <Link
                                                to={`/update/${item.form_code}`}
                                            >
                                                <FaPencilAlt className="link-primary" />
                                            </Link>
                                        </td>
                                        <td>
                                            <FaFileExport
                                                className="link-primary"
                                                onClick={() => {
                                                    export_db(
                                                        item.form_code,
                                                        token
                                                    );
                                                }}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </Table>

                <PaginationComponent
                    response={response}
                    setPaginate={setPaginate}
                />
            </div>
        </div>
    );
};

export default MyForms;
